import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Plus, Trash2, ListChecks, Sparkles } from 'lucide-react';
import { api } from '../../lib/api';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { useCoachT } from '../../lib/coachI18n';
import { STEPS_EVENT } from './CoachPanel';

/* Lista "Prossimi step" nella scheda cliente (dal Coach AI o manuali) */
export const NextStepsCard = ({ leadId }) => {
  const { t } = useCoachT();
  const [steps, setSteps] = useState([]);
  const [text, setText] = useState('');
  const [denied, setDenied] = useState(false);

  const load = useCallback(async () => {
    try {
      const r = await api.get(`/coach/leads/${leadId}/next-steps`);
      setSteps(r.data);
    } catch (e) {
      if (e?.response?.status === 403) setDenied(true);
      setSteps([]);
    }
  }, [leadId]);

  useEffect(() => {
    load();
    const h = (e) => e.detail?.leadId === leadId && load();
    window.addEventListener(STEPS_EVENT, h);
    return () => window.removeEventListener(STEPS_EVENT, h);
  }, [leadId, load]);

  const add = async () => {
    if (!text.trim()) return;
    try {
      await api.post(`/coach/leads/${leadId}/next-steps`, { text });
      setText('');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Errore');
    }
    load();
  };
  const toggle = async (s, done) => { await api.patch(`/coach/next-steps/${s.id}`, { done }); load(); };
  const remove = async (s) => { await api.delete(`/coach/next-steps/${s.id}`); load(); };
  const open = steps.filter((s) => !s.done).length;
  if (denied) return null;

  return (
    <div data-testid="next-steps-card">
      <div className="text-[11px] uppercase tracking-wide text-muted-foreground mb-1 flex items-center gap-1.5">
        <ListChecks className="w-3.5 h-3.5" />{t('nextStepsTitle')} {steps.length > 0 && <span data-testid="next-steps-open-count">({open}/{steps.length})</span>}
      </div>
      {!steps.length && <div className="text-xs text-muted-foreground italic">{t('nextStepsEmpty')}</div>}
      <ul className="space-y-1.5">
        {steps.map((s) => (
          <li key={s.id} className="group flex items-start gap-2 text-sm" data-testid={`next-step-${s.id}`}>
            <Checkbox checked={s.done} onCheckedChange={(v) => toggle(s, !!v)} className="mt-0.5" data-testid={`next-step-check-${s.id}`} />
            <span className={`flex-1 ${s.done ? 'line-through text-muted-foreground' : ''}`}>
              {s.source === 'coach_ai' && <Sparkles className="inline w-3 h-3 mr-1 text-[#C9A227]" />}{s.text}
            </span>
            <button type="button" onClick={() => remove(s)} className="opacity-0 group-hover:opacity-100 transition-opacity text-muted-foreground hover:text-red-600" data-testid={`next-step-delete-${s.id}`}><Trash2 className="w-3.5 h-3.5" /></button>
          </li>
        ))}
      </ul>
      <div className="flex gap-1.5 mt-2">
        <Input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && add()} placeholder={t('stepPh')} className="h-8 text-sm" data-testid="next-step-input" />
        <Button size="sm" onClick={add} disabled={!text.trim()} data-testid="next-step-add"><Plus className="w-4 h-4" /></Button>
      </div>
    </div>
  );
};
